import p from "@babel/runtime/helpers/esm/objectSpread2";
import S from "@babel/runtime/helpers/esm/toConsumableArray";
import h from "@babel/runtime/helpers/esm/classCallCheck";
import y from "@babel/runtime/helpers/esm/createClass";
import m from "@babel/runtime/helpers/esm/assertThisInitialized";
import b from "@babel/runtime/helpers/esm/inherits";
import I from "@babel/runtime/helpers/esm/createSuper";
import c from "@babel/runtime/helpers/esm/defineProperty";
import { sstyled as k } from "@semcore/utils/lib/core/index";
import C, { Component as w, sstyled as P, assignProps as v } from "@semcore/core";
import g from "react";
import { Flex as A } from "@semcore/flex-box";
import { Collapse as R } from "@semcore/animation";
import { Text as $ } from "@semcore/typography";
import E from "@semcore/icon/ChevronRight/m";
import z from "@semcore/icon/ChevronRight/l";
import B from "@semcore/utils/lib/enhances/keyboardFocusEnhance";
import D from "@semcore/utils/lib/uniqueID";
import { cssVariableEnhance as F } from "@semcore/utils/lib/useCssVariable";
var x = (
  /*__reshadow_css_start__*/
  (k.insert(
    /*__inner_css_start__*/
    '.___SItemToggle_1swd4_gg_{display:flex;align-items:center;position:relative;cursor:pointer;outline:0}.___SItemToggle_1swd4_gg_.__keyboardFocused_1swd4_gg_:not(._tabIndex_-1_1swd4_gg_)::after{position:absolute;display:block;content:"";top:3px;right:3px;bottom:3px;left:3px;box-shadow:var(--intergalactic-keyboard-focus, 0px 0px 0px 3px rgba(0, 143, 248, 0.5));pointer-events:none;z-index:3}.___SItemToggle_1swd4_gg_.__use_1swd4_gg_.__use_1swd4_gg_{color:var(--intergalactic-text-primary, #191b23);font-weight:var(--intergalactic-regular, 400)}.___SItemToggle_1swd4_gg_.__use_1swd4_gg_._use_primary_1swd4_gg_{background-color:var(--intergalactic-bg-secondary-neutral, #f4f5f9);padding:var(--intergalactic-spacing-2x, 8px) var(--intergalactic-spacing-3x, 12px);margin-bottom:var(--intergalactic-spacing-05x, 2px)}@media (hover:hover){.___SItemToggle_1swd4_gg_.__use_1swd4_gg_._use_primary_1swd4_gg_:hover{background-color:var(--intergalactic-bg-secondary-neutral-hover, #e0e1e9)}}.___SItemToggle_1swd4_gg_.__disabled_1swd4_gg_{opacity:var(--intergalactic-disabled-opacity, 0.3);cursor:default}.___SItemChevron_1swd4_gg_{transform:rotate(0deg);transition:transform calc(var(--intergalactic-duration-accordion, 200)*1ms) ease-out;fill:var(--intergalactic-icon-primary-neutral, #6c6e79)}.___SItemChevron_1swd4_gg_.__selected_1swd4_gg_{transform:rotate(90deg)}@media (prefers-reduced-motion){.___SItemChevron_1swd4_gg_{transition:none}}',
    "1swd4_gg_"
  ), {
    __SItemToggle: "___SItemToggle_1swd4_gg_",
    _keyboardFocused: "__keyboardFocused_1swd4_gg_",
    "_tabIndex_-1": "_tabIndex_-1_1swd4_gg_",
    _use: "__use_1swd4_gg_",
    _use_primary: "_use_primary_1swd4_gg_",
    _disabled: "__disabled_1swd4_gg_",
    __SItemChevron: "___SItemChevron_1swd4_gg_",
    _selected: "__selected_1swd4_gg_"
  })
), u = /* @__PURE__ */ function(l) {
  b(o, l);
  var i = I(o);
  function o() {
    var r;
    h(this, o);
    for (var e = arguments.length, n = new Array(e), t = 0; t < e; t++)
      n[t] = arguments[t];
    return r = i.call.apply(i, [this].concat(n)), c(m(r), "handleToggleInteraction", function(a) {
      var s = r.asProps.value;
      if (Array.isArray(s)) {
        var _ = s.indexOf(a), d = S(s);
        _ === -1 ? d.push(a) : d.splice(_, 1), r.handlers.value(d);
      } else
        r.handlers.value(s === a ? null : a);
    }), r;
  }
  return y(o, [{
    key: "uncontrolledProps",
    value: function() {
      return {
        value: null
      };
    }
  }, {
    key: "getItemProps",
    value: function(e) {
      var n = e.value, t = this.asProps, a = t.value, s = t.duration, _ = t.use, d = Array.isArray(a) ? a.includes(n) : a === n;
      return {
        selected: d,
        duration: s,
        use: _,
        $handleInteraction: this.handleToggleInteraction
      };
    }
  }, {
    key: "render",
    value: function() {
      var e = this.asProps.Children;
      return /* @__PURE__ */ g.createElement(e, null);
    }
  }]), o;
}(w);
c(u, "displayName", "Accordion");
c(u, "style", x);
c(u, "defaultProps", {
  defaultValue: [],
  use: "secondary"
});
c(u, "enhance", [F({
  variable: "--intergalactic-duration-accordion",
  fallback: "200",
  map: Number.parseInt,
  prop: "duration"
})]);
var f = /* @__PURE__ */ function(l) {
  b(o, l);
  var i = I(o);
  function o() {
    var r;
    h(this, o);
    for (var e = arguments.length, n = new Array(e), t = 0; t < e; t++)
      n[t] = arguments[t];
    return r = i.call.apply(i, [this].concat(n)), c(m(r), "handleClick", function() {
      var a = r.asProps, s = a.value, _ = a.$handleInteraction;
      _(s);
    }), r;
  }
  return y(o, [{
    key: "getToggleProps",
    value: function() {
      var e = this.asProps, n = e.value, t = e.uid;
      e.selected;
      var a = e.disabled, s = e.use;
      return {
        use: s,
        disabled: a,
        onClick: a ? void 0 : this.handleClick,
        id: "igc-".concat(t, "-").concat(n, "-toggle"),
        tag: "h3",
        size: 300
      };
    }
  }, {
    key: "getToggleButtonProps",
    value: function() {
      var e = this.asProps, n = e.value, t = e.uid, a = e.selected, s = e.disabled;
      return {
        disabled: s,
        id: "igc-".concat(t, "-").concat(n, "-toggle-button"),
        "aria-expanded": a ? "true" : "false",
        "aria-controls": a ? "igc-".concat(t, "-").concat(n, "-collapse") : void 0
      };
    }
  }, {
    key: "getCollapseProps",
    value: function() {
      var e = this.asProps, n = e.selected, t = e.uid, a = e.duration, s = e.value;
      return {
        selected: n,
        duration: a,
        id: "igc-".concat(t, "-").concat(s, "-collapse"),
        role: "region",
        "aria-labelledby": "igc-".concat(t, "-").concat(s, "-toggle-button")
      };
    }
  }, {
    key: "getChevronProps",
    value: function() {
      var e = this.asProps, n = e.selected, t = e.size;
      return {
        selected: n,
        size: t
      };
    }
  }, {
    key: "render",
    value: function() {
      var e = this.asProps.Children;
      return /* @__PURE__ */ g.createElement(e, null);
    }
  }]), o;
}(w);
c(f, "displayName", "Item");
c(f, "style", x);
c(f, "enhance", [D()]);
var T = /* @__PURE__ */ function(l) {
  b(o, l);
  var i = I(o);
  function o() {
    var r;
    h(this, o);
    for (var e = arguments.length, n = new Array(e), t = 0; t < e; t++)
      n[t] = arguments[t];
    return r = i.call.apply(i, [this].concat(n)), c(m(r), "toggleRef", /* @__PURE__ */ g.createRef()), c(m(r), "handleKeyDown", function(a) {
      a.key === "Enter" ? r.toggleRef.current === a.target && a.currentTarget.click() : a.key === " " && (a.preventDefault(), r.toggleRef.current === a.target && a.currentTarget.click());
    }), r;
  }
  return y(o, [{
    key: "render",
    value: function() {
      var e = this.asProps, n, t = this.asProps, a = t.styles;
      t.disabled;
      var s = t.use, _ = $;
      return n = P(a), /* @__PURE__ */ g.createElement(_, n.cn("SItemToggle", p({}, v({
        use: s,
        ref: this.toggleRef,
        onKeyDown: this.handleKeyDown
      }, e))));
    }
  }]), o;
}(w);
c(T, "enhance", [B()]);
function K(l) {
  var i = arguments[0], o, r = l.styles, e = l.size, n = e === "l" ? z : E;
  return o = P(r), /* @__PURE__ */ g.createElement(n, o.cn("SItemChevron", p({}, v({}, i))));
}
function N(l) {
  var i = arguments[0], o, r = l.styles, e = A;
  return o = P(r), /* @__PURE__ */ g.createElement(e, o.cn("SToggleButton", p({}, v(p({
    alignItems: "center",
    role: "button"
  }, l), i))));
}
function j(l) {
  var i = arguments[0], o = l.selected, r = o;
  return /* @__PURE__ */ g.createElement(R, v({
    visible: r,
    interactive: !0,
    inert: r ? void 0 : "",
    "aria-hidden": !r
  }, i));
}
var q = C(f, {
  Toggle: T,
  Chevron: K,
  ToggleButton: N,
  Collapse: j
}), se = C(u, {
  Item: q
}), ie = function(i) {
  return i;
};
export {
  f as RootItem,
  se as default,
  ie as wrapAccordion
};
